// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AA5f","col":"styles_col__1W9s5"};